import { useTelegram } from '@/composables/useTelegram'

export default {
  install(app) {
    const telegram = useTelegram()
    app.provide('telegram', telegram)
    telegram.init()
  },
}
